module.exports = __webpack_public_path__ + "img/back-arrow.d77df5e4.svg";